module.exports = __webpack_public_path__ + "03_long_black.86c22286.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_long_black.png
// module id = Qblf
// module chunks = 0